import {TOGGLE_ACTIONS_POPUP} from '../actions/header-ui-actions';

const initialState = {
  isActionsPopupVisible: false
};

export function headerUiState(state = initialState, {type}) {
  switch (type) {
    case TOGGLE_ACTIONS_POPUP:
      return {
        ...state,
        isActionsPopupVisible: !state.isActionsPopupVisible
      };
    default:
      return state;
  }
}
